<template>
  <v-snackbar :value="showNotification" multi-line top right :color="type" @input="showHide">
    <span style="white-space: pre;">{{ message }}</span>
    <template v-slot:action="{ attrs }">
      <v-btn text v-bind="attrs" @click="hide"><v-icon>mdi-close</v-icon></v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'BaseNotification',
  computed: {
    ...mapGetters({
      message: 'general/message',
      type: 'general/typeNotification',
      showNotification: 'general/showNotification'
    })
  },
  methods: {
    hide() {
      this.$store.dispatch('general/refreshNotification');
    },
    showHide(value) {
      if (!value) {
        this.hide();
      }
    }
  }
};
</script>
